import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
interface SegmentedControlProps {
  value?: any;
  onChange: (value: any) => void;
  options: {
    value: string;
    label: React.ReactNode;
    icon: React.ReactNode;
  }[];
}
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({
  theme
}) => ({
  borderRadius: theme.buttonRadius.main,
  backgroundColor: theme.palette.monochrome.main,
  '& .MuiToggleButton-root': {
    borderColor: 'transparent',
    borderRadius: theme.buttonRadius.main,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.outlinedBorder.main
    },
    '.MuiSvgIcon-root': {
      marginRight: theme.spacing(1)
    }
  }
}));
export function SegmentedControl({
  options,
  value,
  onChange
}: SegmentedControlProps) {
  return <StyledToggleButtonGroup value={value} exclusive onChange={(e, val) => onChange(val)}>
      {options.map(option => <ToggleButton value={option.value} disabled={value === option.value} key={option.value}>
          {option.icon} {option.label}
        </ToggleButton>)}
    </StyledToggleButtonGroup>;
}